import { ListProOpenJobCountsRequest } from '@taxfyle/api-internal/internal/job_stats_pb'

import { collection } from 'infra/collection'
import { Id } from 'types/definitions'
import { JobStatsAPI } from './API'
import { ProOpenJobCountDTO } from './dtos'
import { ProOpenJobCount } from './ProOpenJobCount'

export default class JobStatsStore {
  proOpenJobCounts = collection<ProOpenJobCountDTO, ProOpenJobCount>({
    create: () => new ProOpenJobCount(),
    getDataId: (data) => data.workspaceId,
    getModelId: (model) => model.workspaceId,
  })

  constructor(private api: JobStatsAPI) {
    this.listProOpenJobCounts = this.listProOpenJobCounts.bind(this)
  }

  async listProOpenJobCounts(userPublicId: Id) {
    const result = await this.api.listProOpenJobCounts(
      new ListProOpenJobCountsRequest().setUserId(Id.assert(userPublicId))
    )

    const proOpenJobCounts = result
      .getProOpenJobCountsList()
      .map((dto) => dto.toObject())

    return this.proOpenJobCounts.set(proOpenJobCounts)
  }
}
